import React from 'react';
import NumberFormat from 'react-number-format';


export const ThoNhuong = (props) => {


    const ShowEdit = () => {
        props.showEditThongTin();
    }



    return (
        <div className="thong-tin">
            {
                props.thongTin.tenxa ? <table className="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th colSpan="2"> Bản đồ thổ nhưỡng
                            {
                                    props.admin ? <button type="button" className="btn btn-primary btn-sm suathongtin" onClick={ShowEdit}><i className='fas fa-edit'></i></button> : ''
                                }
                            </th>
                        </tr>
                        <tr>
                            <th className="col-name">Tên</th>
                            <th>Thông tin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-name">Huyện</td>
                            <td>Chư Pưh</td>
                        </tr>
                        <tr>
                            <td className="col-name">Xã</td>
                            <td>{props.thongTin?.tenxa}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Diện tích(ha)</td>
                            <td>
                                <NumberFormat value={props.thongTin?.dt_ha} displayType={'text'} thousandSeparator={true} decimalScale={2}></NumberFormat>
                            </td>
                        </tr>
                        <tr>
                            <td className="col-name">Kh Đất</td>
                            <td>{props.thongTin?.symbol_dat}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Tên đất</td>
                            <td>{props.thongTin?.tendat}</td>
                        </tr>
                    </tbody>
                </table> : <h5 className="text-center">Không có thông tin</h5>
            }
        </div>
    )
};